<template>
  <div class="company" style="min-width:1440px;">
    <div class="second_banner">
      <!-- <img class="banner_img" src="../assets/img/union_banner.png" alt /> -->
      <img class="banner_img" :src="mechanism.data.data.url" alt />
    </div>
   <div class="second_main animated fadeInUp" style="padding-left:20%;padding-right:20%">
     <div>
        <el-tabs tab-position="left" v-model="name" >
          <el-tab-pane v-for="item in list" :name="item.id" :label=item.titleCh>
            <span slot="label" ref="zuodagfdafas">
              <i class="el-icon-caret-right" v-if="name==item.id"></i>
              <span style="font-size:14px;font-weight: bold;">{{item.titleCh}}</span>
              <!-- <span v-else>Union Constitution</span> -->
              <!-- <img class="banner_img" src="../assets/img/zuoBiao.png" alt  /> -->
            </span>
            <div class="company_item">
              <div style="text-align:left" v-html="item.content">{{item.content}}</div>
              <!-- <p>长春世界雕塑园位于长春市核心区，占地面积92公顷，其中水域面积11.8公顷，是集自然山水与人文景观于一体现代城市雕塑主题景区，国家AAAAA级景区, 首批“国家重点公园”,首批“创造未来文化遗产”示范单位，并获得了“新中国城市雕塑建设成就奖”中唯一一个"雕塑公园成就奖"。</p>
              <p>景区始建于2000年，2003年9月5日正式对外开放。通过长春国际雕塑作品邀请展等大型活动，园内汇集了来自五大洲216个国家和地区的10021件（组）雕塑、绘画等艺术作品，其中雕塑8337件（组）、绘画1676幅、书法8幅。它们材质丰富、风格迥异，充分体现了公园的主题“友谊·和平·春天。”</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/1.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/2.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/3.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/4.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/5.png" alt="">
                </div>
              </div>
              <div class="big_img">
                <img src="../assets/img/member/6.png" alt="">
              </div> -->
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="圣•乌尔班雕塑公园">
            <div class="company_item">
              <p>坐落在迷人的卢瑟恩附近的瑞士圣·乌尔班雕塑公园，于2006年对外开放，由艺术展览馆、雕塑公园、雕塑艺术之家三部分构成，展出来自26个国家艺术家的雕塑作品、绘画、插画、音像等。公园长期活跃于经济、政治、传媒等领域。此外，公园的艺术家培养计划志再培养新一代的青少年艺术家。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/7.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/8.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/9.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/10.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/11.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/12.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/13.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/14.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/15.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/16.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="贝丁顿雕塑花园">
            <div class="company_item">
              <p>米歇尔和盖·贝丁顿买下了一座桑葚农舍，从1995年起，他们还曾在里面住了一段时间。</p>
              <p>在这座农舍的周围是一片美丽的花园，这片花园是由英国景观设计师奈杰尔设计，还有一片七公顷的土地上，到处都是橡树和橄榄树，与旁边的梯田相映成趣，放眼望去，百合花、兰花与小溪一路相伴，唱着歌消失在山谷深处。这让人如醉的美景无不尽显着普罗旺斯的独特魅力。</p>
              <p>米歇尔和盖·贝丁顿在巴尔热蒙市有一家经营很久的当代艺术馆，从2007年开始他们在普罗旺斯的这片属于他们自己的土地上展出雕塑以及陶艺作品，在2010年当代艺术观成立10周年之际，他们的雕塑花园还对公众开放，展出了70多件来自前世界新老雕塑家的精品。</p>
              <p>在那一年，贝丁顿雕塑花园迎来了1000多名游客，无论在开放日还是预约日，都有一群热爱雕塑，喜欢贝丁顿的人来欣赏游玩。</p>
              <p>有这样一群热爱雕塑花园的人，他们没有理由不提高对自己的要求。在2012年，他们决定无论是在艺术上还是自然景观上，他们都会努力把这里打造成成普罗旺斯蔚蓝海岸大区的佼佼者。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/67.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/68.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/69.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/70.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/71.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="波士顿雕塑家艺术馆">
            <div class="company_item">
              <p>波士顿雕塑家艺术馆由18位波士顿地区的艺术家们于1992年共同创建，旨在展现与提升有创新，有挑战的雕塑作品与装置艺术。波士顿雕塑家艺术馆是美国唯一一个拥有独自展览空间的雕塑家们的组织。这种合作模式已经促成250多个展览，展示了来自36个国家，48个州的58位雕塑家的作品。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/17.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/18.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/19.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/20.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/21.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/22.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/23.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/24.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/25.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/26.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="卡罗尔•富尔曼雕塑基金会">
            <div class="company_item">
              <p>卡罗尔•富尔曼雕塑基金会于2011年建成，该基金会致力于启发人们对艺术的兴趣和热情，并通过举办展览，提供实习机会和补助金来鼓励和奖励值得帮助的艺术家。基金会计划通过组织年度艺术展介绍这些艺术家，并希望以此促进创新的艺术表现形式和创新进程的产生。</p>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/27.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/28.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/29.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="基安蒂雕塑公园">
            <div class="company_item">
              <p>基安蒂雕塑公园于2004年5月正式成立，位于锡耶纳以北5英里，面积17英亩，由非营利性文化组织经营，所有的收入都用于公园的维护与发展。目前，该公园是在意大利拥有最多的室外雕塑艺术品的公园，这里会展出自己的永久性馆藏作品，同时，全世界雕塑家的优秀作品也会在这里进行展出。</p>
              <p>基安蒂雕塑公园由罗萨尔芭和皮耶罗·加亚多斯设计，他们的设计考虑周到，让自然与艺术完美结合，使这里的当代艺术品处处释放着激情。他们选择的是七公顷和冬青树和橡树林，因为之前这里是用来养野猪的场地，而且一直是被栅栏围起来的，所以非常的原生态。艺术家们被邀请参观公园的这片森林，他们都可以为他们的雕塑作品选择合适的摆放空间。这对夫妻设计师也是艺术收藏者，他们当然也为自己留了一个空间来，展示他们的当代艺术收藏品，以分享给其他的艺术爱好者。现在这里已经收藏了30位艺术家的雕塑作品。其中最引人注目的一件作品是竞技场雕塑，人们既能在其中表演，实现它的实用功能，同时，它也是一件供人欣赏的钢雕艺术品。所有的这些作品来自各个不同的国家、民族，不是所有作品都被人们熟知，他们会挑一些在欧洲不是很出名的作品进行宣传。</p>
              <p>我们感叹这里的雕塑作品会与自然这样的和谐，无论从作品周围小环境的搭配上，还是与自然界的各种声音，色彩，光线的配合上都是无可挑剔的，这些人为的艺术品都没有超越自然，相反，他们可以彼此融合，并且相得益彰。</p>
              <p>在欧洲，这已经成了人们来托斯卡纳度假时必然会停留的一站，在夏季，6月上旬到8月末，公园会安排12场露天剧的现场表演，既有爵士，也有歌剧、福音等等。但是很多美洲人对此还不是很了解。</p>
              <p>到目前为止，基安蒂雕塑公园是锡耶纳省唯一一处示范当代艺术的指定的地点。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/30.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/31.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/32.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/33.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/34.png" alt="">
                </div>
              </div>
              <div class="big_img">
                <img src="../assets/img/member/35.png" alt="">
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="雕塑庭园">
            <div class="company_item">
              <p>雕塑庭园（美国）是一个42英亩的非盈利性公共雕塑公园，坐落在费城和纽约之间的新泽西州的汉密尔顿，这座公园在去年吸引了20多万游客。公园始建于1992年，是前新泽西州博览会的所在地，后苏沃德·强生先生为培养人们对当代雕塑的理解与欣赏，将此处重新改建。这一美好的愿景通过一些展览、教学、表演活动以及旅游设施得以实现，使得当代艺术之美通过人们的发现和学习得以展现。雕塑庭院（美国）收藏了来自世界各地享有盛誉的超过270组的雕塑作品。这里吸引着新兴的艺术家，包括著名的雕塑家安东尼·卡罗、汤姆·奥特尼斯、乔治·席格、克莱门特·米德莫尔、贝弗利·佩珀、雷德·格鲁姆斯、奇奇·史密斯、艾萨克·威特金，以及公园的创始人苏沃德·强生。</p>
              <p>这里精心打造了一片独特而私密的植物园，供游客们欣赏雕塑，参与到不同的艺术活动和项目中。这所植物园种植了200个品种的树木，上千种开花灌木，同时设计了或宏伟或隐秘的设施，所有这些都点缀着艺术，吸引着游客。其中，旋转室内的画廊展览、演艺活动、教育项目、家庭活动，以及享有盛誉的休息区，可供人们进一步感知艺术、增长知识、提高兴趣、深化理解。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/36.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/37.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/38.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/39.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/40.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/41.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/42.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/43.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/44.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/45.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="佩德维尔露天雕塑博物">
            <div class="company_item">
              <p>佩德维尔露天雕塑博物馆由雕塑家奥亚尔斯﹒阿尔维兹﹒菲尔德斯（OjarsArvidsFeldbergs）创立，于1991年对外开放，目前该馆已经成为拉脱维亚的历史遗迹。博物馆占地面积100公顷，覆盖可耕种田地、茂盛的绿地、平缓的山坡、幽深的沟壑、起伏的群山、蜿蜒的河流，以及鸟类和野生动物活跃的森林。这里是雕塑家、画师、名版画家、表演艺术家们的理想天堂，在这里人们可以自由地展示与表达他们的创意。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/46.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/47.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/48.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/49.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/50.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/51.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/52.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/53.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="新奥尔良雕塑公园">
            <div class="company_item">
              <p>新奥尔良雕塑公园将本土的，地区的和各国艺术家们的纪念性雕塑作品汇聚在一起举办室外展览，以此来改善新奥尔良市视觉艺术的重修与复原。通过国际艺术家如路易丝﹒布尔乔亚、马克﹒迪﹒苏维罗、亚历山大﹒考尔德的支持，以及他们对于纪念性雕塑作品和积极的视觉符号两个项目的贷款，助力新奥尔良的复苏。估算每年有一千万游客观赏一至多个摆放在城市各处的这类雕塑作品。</p>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/54.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/55.png" alt="">
                </div>
              </div>
              <div class="two_img">
                <div class="img_box">
                  <img src="../assets/img/member/56.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/57.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/58.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/59.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/60.png" alt="">
                </div>
              </div>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/61.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/62.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/63.png" alt="">
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="苏沃德.强生工作室">
            <div class="company_item">
              <p>苏沃德·强生工作室的创建旨在提升人们对雕塑和公共艺术的欣赏和学习。其基金会通过对苏沃德·强生艺术品的制作、维护、售卖和公募这些方式实现了这一理念。</p>
              <p>此外，坐落在美国新泽西州的工作室建有工作坊，同时提供旅游参观和演说展示，无论游客还是艺术家均可在此学到制作雕塑需要的专业技能和专门知识。强生关于生命主题的雕塑和纪念性雕塑作品的展览在世界各地均有举办，如：澳大利亚悉尼、中国香港、美国洛杉矶、美国纽约、美国华盛顿、意大利罗马、中国大连、乌克兰基辅、土耳其伊斯坦布尔、法国巴黎。</p>
              <div class="three_img">
                <div class="img_box little">
                  <img src="../assets/img/member/64.png" alt="">
                </div>
                <div class="img_box little">
                  <img src="../assets/img/member/65.png" alt="">
                </div>
                <div class="img_box">
                  <img src="../assets/img/member/66.png" alt="">
                </div>
              </div>
              
            </div>
          </el-tab-pane> -->
        </el-tabs>
     </div>
    </div>
  </div>
</template>

<script>
import { memberunitList,memberuni,getByNav } from '../api/api'
export default {
  name: "company",
  
  data() {
    return {
      gao:"",
      name:'',
      mechanism:"",
      list:[],
      banners: [
        {
          id: 1,
          link: "/",
          url: require("../assets/img/banner1.png"),
        },
        {
          id: 2,
          link: "/",
          url: require("../assets/img/banner2.png"),
        },
      ],
    };
  },
  created(){
    let navigationId = {
      navigationId:2
    }
    memberunitList({...navigationId}).then(res=>{
      console.log(res)
    })
    navigationId = {
      navigationId:3
    }
    memberuni({...navigationId}).then(res=>{
      this.list=res.data.page.rows
      this.name=res.data.page.rows[0].id
    })
    let getBynavid3 = {
      navigationId:3
    }
    getByNav({...getBynavid3}).then(res=>{
      //console.log(res)
      this.mechanism = res
    })
  },
  mounted() {
    // this.getLocation();
    // this.initMap();
    // this.init();
    // debugger
    // this.gao=this.$refs.zuodagfdafas.clientHeight+"px";
    // debugger
    // this.wei=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-150
    // this.weis=this.$refs.zhuanZi.getBoundingClientRect().left+this.$refs.zhuanZi.clientWidth-200
    // this.weiTop=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight/2
    // // debugger
    // this.weiTops=this.$refs.zhuanZi.offsetTop+this.$refs.zhuanZi.clientHeight-this.$refs.imgs.clientHeight
    // this.weiTop=this.$refs.zhuanZi.getBoundingClientRect().top
    // this.mi=this.$refs.zhuanZi.clientHeight
    // debugger
    // debugger
    // debugger
    // window.addEventListener('scroll',this.handleScrollx,true)
    // debugger
  },
 
};
</script>

<style >
  /* #app /deep/ .el-tabs--left .el-tabs__item.is-left{
    text-align:left;
  } */
  #app /deep/ .el-tabs--left .el-tabs__item.is-left {
    border-bottom:1px solid #F0F0F0;
    height:70px;
    padding: 15px 20px;
  }
</style>
<style lang="less" scoped>
// /deep/ .el-tabs__item{
  //   font-size:18px
// }
/deep/ .el-tabs--left .el-tabs__item.is-left{
  text-align: left;
    font-size:18px;
    
  }
  .banner_img{
    height:400px
  }
.company {
  width: 100%;
  // height: 100%;
  .company_item{
    .two_img{
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .img_box{
        width:404px;
        height: 280px;
        cursor: pointer;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          transition: all 1s ease;
        }
        img:hover{
          transform: scale(1.2);
        }
      }
    }
    .three_img{
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .img_box{
        width:404px;
        height: 280px;
        cursor: pointer;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          transition: all 1s ease;
        }
        img:hover{
          transform: scale(1.2);
        }
      }
      .img_box.little{
        width: 197px;
         height: 280px;
         img{
           width: 100%;
           height: 100%;
         }
      }
    }
    .big_img{
      width: 100%;
      height: 274px;
      cursor: pointer;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        transition: all 1s ease;
      }
      img:hover{
        transform: scale(1.2);
      }
    }
  }
}
</style>